import React, {useCallback, useMemo} from 'react';
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";
import useRuneFunc from "../../common/hooks/useRuneFunc";
import runeShards from "../../store/static_json/runeShards";
import runeShards_en from "../../store/static_json/runeShards_en";
import styled from "styled-components";
import DetailMapRune from "../ChampionsDetail/ChampionsDetailContent/ChampionsDetailRunes/DetailPrimaryRunes";


const HeaderBox = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 12px;
  font-weight: 500;
  color: ${props => props.theme.color.dark_100};
  padding-left: 12px;
  border-bottom: 1px solid ${props => props.theme.color.default_border_color};
  position: relative;
  height: 26px;
`;


const RuneContent = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  height: 100%;
`;
const RuneBox = styled.div`
  display: flex;
  flex-direction: row;
  height: 100%;
  justify-content: space-between;
  width: 200px;
  border-radius: 6px;
`;
const MainRuneWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 4px 0;
`;

const SubRuneWrapper = styled.div`
  padding: 7px 0;
  height: 100%;
  justify-content: space-between;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 80px;
`;


const SubRuneBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

const SubRune = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 24px;
  width: 100%;

  justify-content: space-between;

  & + & {
    margin-top: 8px;
  }

  .detailRunes {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 24px;
    height: 24px;
  }

  .selected-rune {
    width: 24px;
    height: 24px;
  }
`;

const ShardRune = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 16px;
  margin: 3px 0;
  justify-content: space-between;


  .detailRunes {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 16px;
    height: 16px;
  }

  .selected-rune {
    width: 16px;
    height: 16px;
  }
`;


const MainSubRune = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 32px;
  width: 100%;
  justify-content: center;

  & + & {
    gap: 4px;
    margin-top: 16px;
  }

  .detailRunes {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 32px;
    height: 32px;
  }

  .selected-rune {
    width: 32px;
    height: 32px;
  }
`;


const Wrapper = styled.div`
  border-radius: 6px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
`;


const ShardWrapper = styled.div`
    width: 100%;
`;

const LlmRune = ({runeList, customRunes}) => {
    const {i18n, t} = useTranslation();
    const runes = useSelector((state) => state.imageStore.runes);
    const {getRuneBorderColor} = useRuneFunc();
    const currentRuneShards = useMemo(() => ['ko', 'ko-KR'].includes(i18n.language) ? runeShards : runeShards_en, [i18n.language]);
    const findCategoryRune = useCallback((runeData, findValue) => {
        return runeData.find((data) => data.id === findValue);
    }, []);

    const findChildRune = useCallback((categoryRune = [], findValue) => {
        return categoryRune.find((data) => {
            if (data.id === findValue) {
                return true;
            } else if (Array.isArray(data.runes)) {
                return findCategoryRune(data.runes, findValue);
            }
        });
    }, [findCategoryRune]);


    const findParentRune = useCallback((categoryRune = [], findValue) => {
        try {
            if (typeof findValue === 'number') {
                return categoryRune.find((data) => {
                    if (data.id === findValue) {
                        return true;
                    } else {
                        return findChildRune(data.slots, findValue);
                    }
                });
            }
            return null;
        } catch (e) {
            return [];
        }

    }, [findChildRune]);

    const selectedRune = useMemo(() => findParentRune(runes, runeList?.rune_main?.[0]), [runes, runeList])
    const subSelectedRune = useMemo(() => findParentRune(runes, runeList?.rune_sub?.[0]), [runes, runeList])

    if (!Array.isArray(runeList?.rune_main) || runeList?.rune_main?.length < 1) return (
        <Wrapper>
        </Wrapper>);

    if (!selectedRune || !subSelectedRune) return (
        <Wrapper>
        </Wrapper>
    )

    return (
        <Wrapper className={'summoner_mastery_wrapper'}>
            <RuneContent>
                <RuneBox>
                    <MainRuneWrapper>
                        {findParentRune(runes, runeList?.rune_main?.[0])?.slots?.map((data, index) => {
                            return (
                                <MainSubRune key={index}>
                                    <DetailMapRune
                                        width={24}
                                        height={24}
                                        selectedRune={[...runeList.rune_main]}
                                        imageBorder={2}
                                        borderColor={getRuneBorderColor(selectedRune.id)}
                                        runes={data.runes}
                                    />
                                </MainSubRune>
                            )
                        })}
                    </MainRuneWrapper>
                    <SubRuneWrapper>
                        <SubRuneBox>

                            {findParentRune(runes, runeList?.rune_sub?.[0])?.slots?.map((data, index) => {
                                if (index === 0) return null
                                return (
                                    <SubRune key={index}>
                                        <DetailMapRune
                                            width={16}
                                            height={16}
                                            selectedRune={[...runeList.rune_sub]}
                                            imageBorder={2}
                                            borderColor={getRuneBorderColor(subSelectedRune.id)}
                                            runes={data.runes}
                                        />
                                    </SubRune>
                                )
                            })}
                        </SubRuneBox>
                        <ShardWrapper>
                            {currentRuneShards?.slots?.map((data, index) => {
                                const selectedRuneData = () => {
                                    if (index === 0) {
                                        return [runeList.rune_stat?.[0]];
                                    } else if (index === 1) {
                                        return [runeList.rune_stat?.[1]]
                                    } else if (index === 2) {
                                        return [runeList.rune_stat?.[2]]
                                    }
                                }
                                return (
                                    <ShardRune key={index}>
                                        <DetailMapRune
                                            width={12}
                                            height={12}
                                            selectedRune={selectedRuneData()}
                                            imageBorder={2}
                                            borderColor={"#46B9AA"}
                                            runes={data.runes}
                                        />
                                    </ShardRune>
                                )
                            })}

                        </ShardWrapper>
                    </SubRuneWrapper>

                </RuneBox>
            </RuneContent>
        </Wrapper>
    );
};

export default LlmRune;